// @ts-nocheck
import React from 'react';
import { Grid, TextField, Typography, FormControlLabel, Switch } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

function OutboundPakForm({
  automation,
  onAutomationChange,
  error,
  processTypes = {},
  classes
}) {
  const { t } = useTranslation();
  const processTypeOptions = Array.isArray(processTypes)
    ? processTypes
    : Object.values(processTypes || {});

  const handleToggle = (e) => {
    const isChecked = e.target.checked;
    onAutomationChange({
      ...automation,
      outboundPak: isChecked,
      inboundPak: isChecked ? automation.inboundPak : false,
      nextProcessTypeId: isChecked ? automation.nextProcessTypeId : null,
    });
  };

  return (
    <>
      <FormControlLabel
        classes={{ root: classes.switchContainer, label: classes.switchLabel }}
        labelPlacement="start"
        control={
          <Switch
            checked={automation.outboundPak}
            onChange={handleToggle}
            name="outboundPak"
          />
        }
        label={t('processTypes.modal_automation.option_outbound_pak')}
      />

      {automation.outboundPak && !automation.branchingEnabled && (
        <Grid container classes={{ root: classes.formGrid }} spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              options={processTypeOptions}
              getOptionLabel={(o) => o.name || ""}
              noOptionsText={t('No hay tipos de proceso disponibles')}
              value={processTypeOptions.find(pt => pt.id === automation.nextProcessTypeId) || null}
              onChange={(_, val) => onAutomationChange({ ...automation, nextProcessTypeId: val?.id || null })}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('processTypes.nextProcessType_form.labels.process_type')}
                  error={!!error}
                  helperText={error}
                />
              )}
            />
            <Typography variant="caption" color="textSecondary">
              {t('processTypes.nextProcessType_form.helpText')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default OutboundPakForm;
